export default function Marquee({ items, className = "" }) {
  const doubled = [...items, ...items];
  return (
    <div className={`vv-marquee py-8 border-y vv-line ${className}`}>
      <div className="vv-marquee-track">
        {doubled.map((item, i) => (
          <div
            key={i}
            className="flex items-center gap-16 font-serif-vv italic text-4xl md:text-6xl text-[color:var(--vv-bone)]/85"
          >
            <span>{item}</span>
            <span className="text-[color:var(--vv-ember)]">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
}
